export function fromDictToArray(dict) {
    const result = [];
    // 临时存储 item-title 和 item-content 的对象
    const temp = {};

    // 遍历数据，按相同的 item 前缀进行归类
    Object.keys(dict).forEach(key => {
        if(key.includes('-')){
            const [prefix, suffix] = key.split('-');
        
            // 如果该前缀还没有在 temp 中，先初始化
            if (!temp[prefix]) {
                temp[prefix] = {};
            }
    
            // 将 title 或 content 放到 temp[prefix] 中
            temp[prefix][suffix] = dict[key];
        }
    });

    console.log(temp);

    // 将 temp 对象转换为数组格式
    Object.values(temp).forEach(item => {
        result.push(item);
    });
    return result;
}

export function formatTimestampToDate(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function pushImg(arr1, arr2) {
    // 遍历arr2，将每个元素添加到arr1的末尾
    console.log(arr1, arr2);
    arr2.forEach((item, index) => {
        if(item.img) arr1[index].img = item.img
        if(item.iconSelected) arr1[index].iconSelected = item.iconSelected
        if(item.icon) arr1[index].icon = item.icon
    });
    return arr1;
}